import { DialogM } from "@common/components/alert/dialog/Dialog"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { ListGroupM } from "@common/components/list/ListGroupM"
import { ListItemM } from "@common/components/list/ListItemM"
import TextM from "@common/components/text/TextM"
import TitleM from "@common/components/text/TitleM"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { putCongrats } from "@data/redux/actions/navigation"
import { liveService } from "@data/services/liveService"
import { formatOccurrenceDate } from "@data/utility/Utils"
import { useNavigation } from "@react-navigation/native"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { useController } from "react-hook-form"
import { View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { importantWarning } from "../../tutor/lives/MoveSessionReasonComponent"
import AbsenceQuotaBadge from "./AbsenceQuotaBadge"

const cannotRecoverReasons = {
    not_biweekly: "Ce type de séance ne peut pas être rattrapé.",
    delay_too_short: "La session Live est dans moins de 2 heures.",
    already_recovery_session:
        "La séance sélectionnée est déjà une séance de rattrapage.",
    max_reached: "Le quota d'absences signalées a été atteint.",
    absence_too_far:
        "Aucune séance de rattrapage disponible pour le moment. Vous serez notifiés par email lorsqu'il y aura des séances disponibles.",
    no_availability:
        "Aucune séance de rattrapage disponible pour le moment. Vous serez notifiés par email lorsqu'il y aura des séances disponibles.",
}

const RecoverLiveSessionComponent = (props) => {
    const {
        control,
        goToNextStep,
        setFormValues,
        student,
        asParent,
        liveSessionId,
        occurrenceDate = null,
        attendanceFlagId = null,
    } = props

    const navigation = useNavigation()

    const getService = !asParent
        ? liveService.getRecoveryPossibilities
        : liveService.getRecoveryPossibilitiesAsParent

    const coreParams = attendanceFlagId
        ? {
              attendance_flag_id: attendanceFlagId,
          }
        : {
              live_session_id: liveSessionId,
              occurrence_date:
                  moment(occurrenceDate).format("YYYY-MM-DD HH:mm"),
          }
    const params = !asParent
        ? {
              ...coreParams,
          }
        : {
              student_email: student?.email,
              ...coreParams,
          }

    useEffect(() => {
        props.apiRequest(getService, {}, {}, params)
    }, [])

    const [recoveryPossibilitiesData, setRecoveryPossibilitiesData] =
        useState(null)

    useApiStatus(
        getService,
        null,
        true,
        (successData) => {
            setRecoveryPossibilitiesData(successData)
            field.onChange(null)
            setFormValues({
                ...control?._formValues,
                recovery_occurrence_id: null,
            })
        },
        () => {}
    )

    const { field } = useController({
        name: "recovery_occurrence_id",
        control,
    })

    const countRecoveredAbsencesInPeriod =
        recoveryPossibilitiesData?.recovered_absences_in_period ?? 0
    const recoveredAbsencesWindowSizeInMonths =
        recoveryPossibilitiesData?.recovered_absences_window_size_in_months ?? 2

    const canRecoverAbsence =
        recoveryPossibilitiesData?.can_recover_absence ?? 1

    const canRecoverNow = recoveryPossibilitiesData?.can_recover_now
    const reasonSlug = recoveryPossibilitiesData?.reason_slug

    const possibleLiveOccurrences =
        recoveryPossibilitiesData?.possible_live_occurrences
    const possibleLiveOccurrencesOptions = possibleLiveOccurrences?.map(
        (occurrence) => {
            const isBestOption =
                occurrence?.is_usual_tutor ||
                (occurrence?.students_count === 1 &&
                    occurrence?.students_same_class === true)
            return {
                label: formatOccurrenceDate(occurrence?.date),
                description: isBestOption ? (
                    <>
                        <FontAwesome5
                            name={"star"}
                            solid
                            size={14}
                            color={theme.colors.success}
                        />
                        <TextM
                            wrap
                            color={theme.colors.success}
                            fontWeight={"Bold"}
                        >
                            {" Meilleur groupe pour " + student?.firstname}
                        </TextM>
                    </>
                ) : null,
                value: occurrence?.id,
            }
        }
    )

    const isRecoveryFlow = !!attendanceFlagId

    const title = isRecoveryFlow
        ? occurrenceDate
            ? `Rattrapage de la séance du ${formatOccurrenceDate(occurrenceDate)}`
            : "Planifier un rattrapage"
        : canRecoverAbsence
          ? `Je vais être absent.e à la séance du ${formatOccurrenceDate(
                occurrenceDate
            )}`
          : "Récapitulatif"

    const description =
        isRecoveryFlow || canRecoverAbsence
            ? null
            : `Date de l'absence : ${moment(occurrenceDate).format(
                  "dddd DD MMMM [à] HH:mm"
              )}`

    const confirmationDialogTitle = isRecoveryFlow
        ? occurrenceDate
            ? `Rattrapage de la séance du ${formatOccurrenceDate(occurrenceDate)}`
            : `Planifier le rattrapage de ${student?.firstname}`
        : `Je signale l'absence de ${student?.firstname} à la séance du ${formatOccurrenceDate(occurrenceDate)}`
    const confirmationDialogText = (occurrenceSelected) =>
        occurrenceSelected && field.value
            ? `Je choisis la séance du ${formatOccurrenceDate(
                  possibleLiveOccurrences?.find(
                      (occurrence) => occurrence?.id === field.value
                  )?.date
              )} pour rattraper`
            : canRecoverAbsence
              ? "Je choisirai une séance de rattrapage plus tard"
              : "La séance ne pourra pas être rattrapée"

    const showConfirmationDialog = (occurrenceSelected = true) => {
        DialogM.show({
            text1: confirmationDialogTitle,
            text2: confirmationDialogText(occurrenceSelected),
            buttonText1: "Envoyer",
            buttonColor1: theme.colors.success,
            onPress: () => {
                goToNextStep()
            },
            buttonText2: "Annuler",
            onPressBack: () => {},
        })
    }

    return (
        <View
            style={{
                alignSelf: "center",
                width: "100%",
                flex: 1,
            }}
        >
            {props.getRecoveryPossibilitiesRequest ||
            props.getRecoveryPossibilitiesAsParentRequest ? (
                <ActivityIndicator
                    animating={true}
                    style={{
                        marginTop: 50,
                    }}
                    size="small"
                    color={theme.colors.primary}
                />
            ) : (
                <>
                    <TitleM
                        wrap
                        fontWeight={"ExtraBold"}
                        style={{ marginBottom: 10 }}
                    >
                        {title}
                    </TitleM>
                    {!isRecoveryFlow && (
                        <AbsenceQuotaBadge
                            used={countRecoveredAbsencesInPeriod}
                            limit={
                                recoveryPossibilitiesData?.recovered_absences_max_per_period
                            }
                            windowMonths={recoveredAbsencesWindowSizeInMonths}
                            studentFirstname={
                                asParent ? student?.firstname : null
                            }
                            style={{ marginBottom: 16 }}
                        />
                    )}
                    {!!description && (
                        <TextM wrap style={{ marginBottom: 20 }}>
                            {description}
                        </TextM>
                    )}
                    {canRecoverAbsence &&
                    canRecoverNow &&
                    possibleLiveOccurrencesOptions?.length > 0 ? (
                        <>
                            <TextM
                                wrap
                                fontSize={18}
                                fontWeight={"Bold"}
                                color={theme.colors.primary}
                            >
                                Je choisis une séance de rattrapage
                            </TextM>
                            <ListGroupM
                                options={possibleLiveOccurrencesOptions}
                                style={{
                                    marginBottom: 160,
                                }}
                                itemHeight={70}
                                renderItem={(item) => {
                                    return (
                                        <ListItemM
                                            onPress={() => {
                                                field.onChange(item.item?.value)
                                                setFormValues({
                                                    ...control?._formValues,
                                                    recovery_occurrence_id:
                                                        item.item?.value,
                                                })
                                            }}
                                            itemHeight={70}
                                            selected={
                                                item.item?.value === field.value
                                            }
                                            option={item.item}
                                        />
                                    )
                                }}
                            />
                        </>
                    ) : canRecoverAbsence ? (
                        <TextM wrap>
                            {canRecoverNow
                                ? cannotRecoverReasons?.["no_availability"]
                                : cannotRecoverReasons?.[reasonSlug]}
                        </TextM>
                    ) : reasonSlug === "max_reached" ? null : (
                        importantWarning(
                            <>
                                <TextM wrap>
                                    {cannotRecoverReasons?.[reasonSlug]}
                                </TextM>
                                <TextM wrap>
                                    Il est toujours possible de signaler
                                    l&apos;absence pour prévenir le masteur,
                                    mais la séance ne pourra pas être rattrapée.
                                </TextM>
                            </>
                        )
                    )}
                    <View
                        style={{
                            position: "absolute",
                            bottom: 0,
                            alignSelf: "center",
                            paddingBottom: 40,
                        }}
                    >
                        <FilledButtonM
                            onPress={showConfirmationDialog}
                            disabled={
                                possibleLiveOccurrencesOptions?.length > 0 &&
                                !field.value
                            }
                            label={"Confirmer"}
                            color={theme.colors.success}
                        />
                        {possibleLiveOccurrencesOptions?.length > 0 && (
                            <FilledButtonM
                                mode={"text"}
                                onPress={() => {
                                    if (isRecoveryFlow) {
                                        navigation.goBack()
                                        return
                                    }
                                    field?.onChange(null)
                                    setFormValues({
                                        ...control?._formValues,
                                        recovery_occurrence_id: null,
                                    })
                                    showConfirmationDialog(false)
                                }}
                                style={{
                                    height: 30,
                                }}
                                contentStyle={{
                                    height: 30,
                                }}
                                labelStyle={{
                                    height: 30,
                                }}
                                label={"Rattraper plus tard"}
                            />
                        )}
                    </View>
                </>
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        formDataUser: state.data.formData?.user,
        getUserRequest: state.api.getUser?.request,
        getRecoveryPossibilitiesRequest:
            state.api.getRecoveryPossibilities?.request,
        getRecoveryPossibilitiesAsParentRequest:
            state.api.getRecoveryPossibilitiesAsParent?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    putCongrats,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecoverLiveSessionComponent)
